import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';
import { NavListItem } from '../NavList';

const desktopNavMenuListItemStyles = css`
  display: inline-block;
  font-family: ${theme.font.family.monospaced};
  font-size: ${theme.font.size.xs};
  font-weight: ${theme.font.weight.medium};
  letter-spacing: 1px;
  line-height: ${theme.lineHeight.reset};
  margin-bottom: 0;
  margin-left: ${theme.spacing.xl}px;
  position: relative;
  text-transform: uppercase;
  width: auto;
`;

const fullWidthStyles = css`
  display: flex;
  margin: 0 0 ${theme.spacing.md}px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

const DesktopNavMenuListItem = ({ panel, isFullWidth, ...props }) => (
  <NavListItem
    className={cx(desktopNavMenuListItemStyles, {
      [fullWidthStyles]: isFullWidth,
    })}
    panel={panel}
    {...props}
  />
);

DesktopNavMenuListItem.defaultProps = {
  isFullWidth: false,
  panel: null,
};

DesktopNavMenuListItem.propTypes = {
  /**
   * Is the list item being displayed full width
   * i.e. a vertical list
   */
  isFullWidth: PropTypes.bool,
  /**
   * Dropdown panel component associated with a search button
   */
  panel: PropTypes.node,
};

export default DesktopNavMenuListItem;
